import { openModal } from "../../alpine/utils/dispatcher";

export function loadAuthModal() {
  htmx.ajax("GET", "/login-modal", {
    target: "#auth-modal",
    swap: "innerHTML",
  });
}

export function handleNoAuthHtmxResponse(event) {
  const xhr = event.detail?.xhr;

  if (!xhr || xhr.status !== 401) return;

  event.detail.shouldSwap = false;
  event.detail.isError = false;

  loadAuthModal();
}

export function handleAuthModalLoaded(event) {
  const target = event.detail?.target;

  const xhr = event.detail?.xhr;

  if (!target || !xhr) return;

  if (target.id !== "auth-modal") return;

  if (xhr.status < 200 || xhr.status >= 300) return;

  openModal("login");
}
